<template>
    <ListenerArtistDetails v-if="isListenerMobile" />
    <ArtistDetails v-else />
</template>

<script>
import ArtistDetails from './ArtistDetails.vue'
import ListenerArtistDetails from './ListenerArtistDetails.vue'

export default {
    name: 'ArtistDetailsEntry',
    components: {
        ArtistDetails,
        ListenerArtistDetails
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
